export enum FedopsInteraction {
  ViewSectionAtSidebarLayout = 'view-section-at-sidebar-layout',
  ViewStepAtSidebarLayout = 'view-step-at-sidebar-layout',
  CompleteStepWithoutFeedback = 'complete-step-without-feedback',
  UpdateFeedbackData = 'update-feedback-data',
  LeaveFromProgram = 'leave-from-program',
}
